import { Object3D } from 'three';
import {
  registerOnHover,
  deregisterOnHover,
} from './hover';

import {
  deregisterObject,
  intersections,
  registerObject,
} from './raycaster';

import {
  setCursor,
  unsetCursor,
  Cursor,
} from './cursor';

// returns true if it wants the click event to propagate
type OnClickCallback = (event: MouseEvent) => boolean | void;

const onClickCallbacks: Record<string, OnClickCallback> = {};
const onClickFallbacks: OnClickCallback[] = [];

document.addEventListener('click', onMouseUp );
function onMouseUp(event: MouseEvent) {
  // event.preventDefault();
  // event.stopPropagation();

  let callbackExecuted = false;

  for (const intersection of intersections) {
    const callback = onClickCallbacks[intersection.object.uuid];
    if (callback) {
      const propagateEvent = callback(event);
      if (!propagateEvent) return;
      callbackExecuted = true;
    }
  }

  if (callbackExecuted) return;
  onClickFallbacks.forEach((fallback) => fallback(event));
}

export function registerOnClick(obj: Object3D, callback: OnClickCallback, cursor: Cursor = Cursor.pointer) {
  if (!onClickCallbacks[obj.uuid]) {
    registerObject(obj); // maybe redundant w/ registerOnHover
    onClickCallbacks[obj.uuid] = callback;
  }

  registerOnHover(
    obj,
    () => setCursor(cursor),
    unsetCursor,
  );
}

// note: not tested yet
export function deregisterOnClick(obj: Object3D) {
  delete onClickCallbacks[obj.uuid]
  deregisterObject(obj); // maybe redundant w/ deregisterOnHover
  deregisterOnHover(obj);
}

export function registerOnClickFallback(callback: OnClickCallback) {
  const notYetRegistered = !onClickFallbacks.find((fallback) => fallback === callback);
  if (notYetRegistered) onClickFallbacks.push(callback);
}

export function deregisterOnClickFallback(callback: OnClickCallback) {
  const index = onClickFallbacks.findIndex((fallback) => fallback === callback);
  if (index !== -1) onClickFallbacks.splice(index, 1)
}
